<article class="container">
  <section class="bg-primary p-4 p-md-6 block-newsletter row">
    @if (block().title && block().text) {
      <h2 class="h3 text-light text-center mb-md-4">{{ block().title }}</h2>
    }
    <div class="col-md-12">
      <div class="flex-md-row gap-4 block-newsletter__inner">
        @if (block().text) {
          <div class="block-newsletter__text text-light simple-markdown--dark-background" [innerHTML]="block().text"></div>
        }
        @if (!block().text) {
          <h2 class="h3 text-light text-center text-md-start mb-4 mb-md-0">{{ block().title }}</h2>
        }
      </div>
    </div>
    <div class="col-md-12">
      <app-newsletter-form class="d-contents" [newsletterList]="this.block().newsletterList || 2"></app-newsletter-form>
    </div>
  </section>
</article>
